import { render } from "./ClientsPage.vue?vue&type=template&id=a0795c16&ts=true"
import script from "./ClientsPage.vue?vue&type=script&lang=ts"
export * from "./ClientsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__